import { NavLink } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import React from 'react';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface UserData {
  UserRole: string;
  // Add other properties as needed
}

function Nav() {
  const isAuthenticated = useIsAuthenticated();

  // const userdetails: UserData[] = JSON.parse(
  //   localStorage.getItem('userdetails') || '[]'
  // );
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const components = userdetails[0]?.components || []; // Ensure components is an array

  const userRoles: string[] =
    process.env.REACT_APP_USER_ROLES?.split(',') || [];
  const superAdmin: string[] =
    process.env.REACT_APP_SUPER_ADMIN?.split(',') || [];


    const navLinks = [
      { path: "/", name: "HomePg", label: "Home" },
      { path: "/HealthPlan", name: "HealthPlan", label: "HealthPlan" },
      { path: "/Inventory", name: "Inventory", label: "Inventory" },
      { path: "/RRDInventory", name: "RRDInventory", label: "Print Inventory" },
      { path: "/PayerForms", name: "PayerForms", label: "Payer Forms" },
      { path: "/Scenarios", name: "Scenarios", label: "Scenarios" },
    ];

    const healthPlanComponents = [
      "HealthPlanMapping",
      "UnmappedHealthPlan",
      "PayerMaster",
      "PayerAddress",
      "HealthPlanMaster",
      "HealthPlanType",
    ];

    const inventoryComponents = [
      "FailedInventoryPage",
      "HIMInventory",
      "InventoryPage",
    ];
  
    // Filter navigation links based on the components available in userdetails
    const accessibleNavLinks = navLinks.filter((link) => {
      if (link.name === "HomePg") {
        // Always show HomePg
        return true;
      }
      if (link.name === "HealthPlan") {
        // Show HealthPlan NavLink if any of the healthPlanComponents are present
        return healthPlanComponents.some((component) => components.includes(component));
      }
      if (link.name === "Inventory") {
        // Show Inventory NavLink if any of the inventory components are present
        return inventoryComponents.some((component) => components.includes(component));
      }
      return components.includes(link.name);
    });

  return (
     <>
      {isAuthenticated && (
        <HStack>
          {accessibleNavLinks
          .filter((link) => !["PayerForms", "Scenarios"].includes(link.name)) // Exclude Payer Forms and Scenarios
          .map((link, index) => (
            <NavLink
              key={index}
              to={link.path}
              style={({ isActive, isPending, isTransitioning }) => ({
                fontWeight: isActive ? "bold" : "",
                color: isActive ? "#002677" : "black",
                viewTransitionName: isTransitioning ? "slide" : "",
                marginRight: "20px",
                textDecoration: isActive ? "underline" : "",
              })}
              className={({ isActive }) => (isActive ? "currPg" : "")}
            >
              {link.label}
            </NavLink>
          ))}
          {userdetails.length > 0 &&
            accessibleNavLinks.some(link => ["PayerForms", "Scenarios"].includes(link.name)) && (
              <Menu isLazy>
                <MenuButton
                  color="white"
                  bgColor="#002677"
                  height="35px"
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  mr="20px"
                >
                  Admin
                </MenuButton>
                <MenuList>
                  {accessibleNavLinks
                    .filter((link) =>
                      ["PayerForms", "Scenarios"].includes(link.name)
                    )
                    .map((link, index) => (
                      <MenuItem key={index}>
                        <NavLink
                          to={link.path}
                          style={({ isActive, isPending, isTransitioning }) => ({
                            fontWeight: isActive ? "bold" : "",
                            color: isActive ? "#002677" : "black",
                            viewTransitionName: isTransitioning ? "slide" : "",
                            marginRight: "20px",
                            textDecoration: isActive ? "underline" : "",
                          })}
                          className={({ isActive }) =>
                            isActive ? "currPg" : ""
                          }
                        >
                          {link.label}
                        </NavLink>
                      </MenuItem>
                    ))}
                </MenuList>
              </Menu>
            )}
        </HStack>
      )}
    </>
  );
}

export default Nav;
